import { AlertTriangle } from 'lucide-react';
import { getSupabaseHost, isRemoteDatabaseInDev, SUPABASE_URL, IS_DEV } from '@/lib/environment';

/**
 * Avviso fisso quando si sviluppa contro un database remoto.
 *
 * `.env.development` ha puntato a lungo allo stesso progetto Supabase di
 * `.env.production`: chi lanciava `bun run dev` stava scrivendo sui dati veri
 * senza che nulla glielo dicesse. Questo nastro rende la cosa impossibile da
 * non notare. In produzione non viene mai reso.
 */
export function RemoteDatabaseBanner() {
  if (!isRemoteDatabaseInDev(SUPABASE_URL, IS_DEV)) return null;

  return (
    <div
      role="alert"
      className="fixed top-0 inset-x-0 z-[9999] flex items-center justify-center gap-2 px-4 py-1.5 bg-amber-500 text-amber-950 text-xs font-medium shadow-md"
    >
      <AlertTriangle className="w-3.5 h-3.5 shrink-0" />
      <span>
        Sviluppo su database <b>remoto</b> ({getSupabaseHost(SUPABASE_URL)}) — le modifiche
        toccano dati veri. Per il locale: <code className="font-mono">supabase start</code>.
      </span>
    </div>
  );
}
